import { EditOutlined, MenuOutlined, PlusOutlined } from '@ant-design/icons'
import { DndContext } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Card, Empty, Skeleton, Table } from 'antd'
import React from 'react'
import ConfirmDeleteModal from '../../staff-and-role-management/ConfirmDeleteModal'
import { useLibrary } from './useLibrary'
import { Button } from 'src/common'
import { AddPostModal } from './AddPostModal'
import { t } from 'i18next'

type Props = { activeTab?: string }

export const LibraryTab = ({ activeTab }: Props) => {
  const {
    sensors,
    setShowModal,
    openConfirmDeleteModal,
    onDragEnd,
    onCloseConfirmModal,
    showModal,
    columns,
    listPosts,
    onClose,
    isGetLibraryLoading,
    isDeletingPostOutLibrary,
    onDeletePostOutLibrary,
  } = useLibrary({ activeTab })

  return (
    <Card>
      <div className="flex items-center justify-between py-[1.25rem] w-full">
        <div
          style={{
            flex: 1,
          }}
        />
        {listPosts?.length <= 8 && (
          <Button
            htmlType="submit"
            type="primary"
            size="middle"
            className="submit__btn loginselected-btn"
            icon={<PlusOutlined className="!text-[16px]" />}
            style={{
              alignSelf: 'flex-end',
            }}
            onClick={() => {
              setShowModal(true)
            }}
          >
            {'Add new'}
          </Button>
        )}
      </div>
      {isGetLibraryLoading ? (
        <Skeleton
          paragraph={{ rows: 4 }}
          style={{
            marginTop: 10,
          }}
        />
      ) : listPosts?.length === 0 ? (
        <>
          <Empty description={t('evolveLanding:no_data')} />
        </>
      ) : (
        <DndContext
          sensors={sensors}
          modifiers={[restrictToVerticalAxis]}
          onDragEnd={onDragEnd}
          autoScroll
        >
          <SortableContext
            // rowKey array
            items={listPosts?.map((i) => i.postId) ?? []}
            strategy={verticalListSortingStrategy}
          >
            <Table
              components={{
                body: {
                  row: Row,
                },
              }}
              pagination={false}
              rowKey="key"
              rowClassName={'!z-0'}
              columns={columns}
              dataSource={listPosts?.map((item, index: any) => {
                return {
                  ...item,
                  key: item?.postId,
                }
              })}
            />
          </SortableContext>
        </DndContext>
      )}
      {showModal && (
        <AddPostModal
          open={showModal}
          onClose={onClose}
          type={'EVOLVE_MEMBER_USE_HEADING'}
          title="Add new blog"
          listSelected={listPosts.map((item) => ({
            postId: item.postId,
            index: item.index,
          }))}
        />
      )}

      <ConfirmDeleteModal
        title="Delete this section "
        content="Are you sure to delete this section?"
        open={openConfirmDeleteModal}
        onClose={onCloseConfirmModal}
        isLoading={isDeletingPostOutLibrary || false}
        onDelete={onDeletePostOutLibrary}
      />
    </Card>
  )
}

interface RowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string
}
const Row = ({ children, ...props }: RowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props['data-row-key'],
  })
  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  }

  return (
    <tr {...props} ref={setNodeRef} style={style} {...attributes}>
      {React.Children.map(children, (child) => {
        if ((child as React.ReactElement).key === 'test') {
          return React.cloneElement(child as React.ReactElement, {
            children: (
              <MenuOutlined
                ref={setActivatorNodeRef}
                style={{ touchAction: 'none', cursor: 'move' }}
                {...listeners}
              />
            ),
          })
        }
        return child
      })}
    </tr>
  )
}
